import { Box, Button, Typography } from '@mui/material';

import {
  QUEUE_VIEW_KEYS,
  type QueueViewKey,
  WORK_VIEW_LABELS,
} from '../../billing/types/encounterWork';
import type { MorningWorklistClaimCounts } from '../types';
import { reportedCount } from '../utils/reported-count';

export function ClaimQueueCounts({
  counts,
  onSelect,
}: {
  counts: MorningWorklistClaimCounts;
  onSelect?: (view: QueueViewKey) => void;
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(5, 1fr)' },
        gap: 1,
      }}
    >
      {QUEUE_VIEW_KEYS.map(view => {
        /* A count the server did not send reads as a dash, never as 0, and
           its tile is no door into a queue the server has not reported on.
           `bill_secondary` reaches the generated counts with
           smartscribe-server GDN-4022 (PR preflight). */
        const count = reportedCount(counts[view]);
        const content = (
          <>
            <Typography variant="caption" color="text.secondary">
              {WORK_VIEW_LABELS[view]}
            </Typography>
            <Typography
              color={count == null ? 'text.disabled' : 'text.primary'}
              sx={{ fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}
            >
              {count ?? '—'}
            </Typography>
          </>
        );
        return onSelect && count != null ? (
          <Button
            key={view}
            color="inherit"
            data-testid={`claim-queue-count-${view}`}
            onClick={() => onSelect(view)}
            sx={{
              alignItems: 'flex-start',
              bgcolor: 'action.hover',
              flexDirection: 'column',
              p: 1,
              textAlign: 'left',
              textTransform: 'none',
            }}
          >
            {content}
          </Button>
        ) : (
          <Box
            key={view}
            data-testid={`claim-queue-count-${view}`}
            sx={{ bgcolor: 'action.hover', borderRadius: 1, p: 1 }}
          >
            {content}
          </Box>
        );
      })}
    </Box>
  );
}
